import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { AuthService } from './shared/service/auth.service';



import { AddAssessmentComponent } from './components/assessment/add-assessment/add-assessment.component';
import { BusinessAssessmentComponent } from './components/assessment/business-assessment/business-assessment.component';
import { AssessmentListComponent } from './components/assessment/assessment-list/assessment-list.component';
import { EditAssessmentComponent } from './components/assessment/edit-assessment/edit-assessment.component';
import { MarkBarHelpComponent } from './modals/markbar-help/markbar-help.component';
import {PracticalOperatingComponent} from './components/assessment/operating-assessment/operating-assessment.component';
import { OperatingAssessmentListComponent } from './components/assessment/operating-assessment-list/operating-assessment-list.component';
import { BusinessAssessmentsListComponent } from './components/assessment/business-assessments-list/business-assessments-list.component';
import {BusinessPlanComponent} from './components/assessment-ft/business-plan/business-plan.component';
import {ResourcesComponent} from './components/assessment-ft/resources/resources.component';
import {CalcRevenueComponent} from './components/assessment-ft/calc-revenue/calc-revenue.component';
import {ActionItemListComponent} from './components/assessment-ft/action-items/action-item-list/action-item-list.component'
import { SDGHelpComponent } from './modals/sdg-help/sdg-help.component';
import {OfferSentenceHelpComponent} from './modals/offer-sentence-help/offer-sentence-help.component';
import { NavigationComponent } from './shared/navigation/navigation.component';
import { LayoutModule } from '@angular/cdk/layout';
import { ReactiveFormsModule } from '@angular/forms';
import {NgxPaginationModule} from 'ngx-pagination';
import {ToastrModule} from 'ngx-toastr';
import { Material } from './modules/material-module';
import { AccountComponent } from './components/account/account.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { ViewsComponent } from './components/views/views.component';
import { ViewsPracticalComponent } from './components/views-practical/views-practical.component';
import {ViewsBusinessAssessmentComponent} from './components/views-business-assessment/views-business-assesment.component'
import { PillarsComponent } from './logic/pillars/pillars.component';
import { TroubleshootComponent } from './components/troubleshoot/troubleshoot.component';
import { ChartsModule } from 'ng2-charts';
import {MatSliderModule} from '@angular/material/slider';
import { FormsModule } from '@angular/forms';
import { OnBoardComponent } from './components/on-board/on-board.component';
import { FooterComponent } from './shared/footer/footer.component';
import { GoalsComponent } from './components/goals/goals.component';
import { AddActionItemComponent } from './components/assessment-ft/action-items/add-action-item/add-action-item.component';
import { HttpClientModule } from '@angular/common/http';
import { ConfirmationBoxComponent } from './components/confirmation-box/confirmation-box.component';
import { EntrepDashComponent } from './components/entrep-dash/entrep-dash.component';
import { ScreenSupportComponent } from './shared/screen-support/screen-support.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SuperAdminDashboardComponent } from './components/super-admin-dashboard/super-admin-dashboard.component';
import { AdminDetailsComponent } from './components/admin-details/admin-details.component';
import { SuperAdminComponent } from './components/super-admin/super-admin.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    AppComponent,
    AddAssessmentComponent,
    BusinessAssessmentComponent,
    EditAssessmentComponent,
    AssessmentListComponent,
    NavigationComponent,
    AccountComponent,
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    ViewsComponent,
    ViewsPracticalComponent,
    ViewsBusinessAssessmentComponent,
    MarkBarHelpComponent, 
    OfferSentenceHelpComponent,
    BusinessPlanComponent,
    ResourcesComponent,
    CalcRevenueComponent,
    ActionItemListComponent, 
    BusinessAssessmentsListComponent,
    SDGHelpComponent,
    PillarsComponent,
    TroubleshootComponent,
    OnBoardComponent,
    FooterComponent,
    GoalsComponent,
    PracticalOperatingComponent,
    OperatingAssessmentListComponent,
    AddActionItemComponent,
    ConfirmationBoxComponent,
    EntrepDashComponent,
    ScreenSupportComponent,
    SuperAdminDashboardComponent,
    AdminDetailsComponent,
    SuperAdminComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    Material,
    ChartsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    NgxPaginationModule,
    ToastrModule.forRoot(),
    MatSliderModule,
    FormsModule
  ],
  providers: [AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
